import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {Store} from '@ngrx/store';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {setItemDisabledStatus} from '../../store/shared-grid.actions';
import {take} from 'rxjs/operators';
import {selectCurrentNavigationPage} from '../../../../features/user-access/user-stores-store/user-store.selectors';
import {ISharedModalBasic, ISharedModalBasicResponse} from '../../../../shared/shared-models/modals/shared-modal-basic';
import {
  SharedModalBasicComponent
} from '../../../../shared/shared-components/components/shared-modal-basic/shared-modal-basic.component';
import {
  IModalDismissResult,
  ModalControllerService
} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {IconColourEnum} from '../../../shared-icons/models/icons-colour.enum';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';

@Component({
    selector: 'app-cell-renderer-disable-item',
    templateUrl: './cell-renderer-disable-item.component.html',
    styleUrls: ['./cell-renderer-disable-item.component.scss'],
    standalone: false
})
export class CellRendererDisableItemComponent implements ICellRendererAngularComp {

  params: ICellRendererParams;
  width: string;
  value: boolean;
  type: string;
  departments: {} = {};
  currentPage: string;

  protected readonly iconColourEnum = IconColourEnum;
  protected readonly icons: typeof IconsEnum = IconsEnum;

  constructor(
    private readonly store: Store,
    private modalController: ModalControllerService,
  ) {
  }

  agInit(params: ICellRendererParams): void {
    this.params = {...params};
    this.params.data = structuredClone(params.data);
    this.value = params.value;
    this.type = params.colDef.field;
    this.store.select(selectCurrentNavigationPage).pipe(take(1)).subscribe((currentPage: string) => {
      this.currentPage = currentPage;
    });
  }

  async onLockIconClick(): Promise<void> {
    const isItemDisabled: boolean = !!this.params?.data?._tags?.includes('disabled');

    if (this.currentPage === 'auto-ordering') {
      const itemDescription: string = (this.params?.data?.desc as string)?.trim() || 'this item';
      const componentProps: ISharedModalBasic = {
        buttonAccept: true,
        buttonAcceptText: isItemDisabled ? 'Enable Item' : 'Disable Item',
        buttonClose: true,
        buttonCloseCross: false,
        buttonCloseText: 'Cancel',
        modalTitle: isItemDisabled ? 'Enable Stock Item' : 'Disable Stock Item',
        modalTitleIcon: this.icons.infoSlabCircleOutline,
        modalTitleIconColor: this.iconColourEnum.yellow,
        contextHeading: isItemDisabled
          ? `Enable ${itemDescription} for stock?`
          : `Disable ${itemDescription} for stock?`,
        contextDescription: [
          'Confirming this action will immediately send the stock update.',
          isItemDisabled
            ? 'The item will be enabled for stock everywhere, including Stock Manager, not only on this order.'
            : 'The item will be disabled for stock everywhere, including Stock Manager, not only on this order.',
          'Your other order lines and quantities stay unchanged.',
        ],
      };

      const modalController = await this.modalController.create({
        component: SharedModalBasicComponent,
        componentProps,
        cssClass: ['shared-basic-modal-css'],
      });

      await modalController.present();
      const modalResponse: IModalDismissResult<ISharedModalBasicResponse> = await modalController.onDidDismiss();

      if (modalResponse?.data?.buttonPressed !== 'button-accept') {
        return;
      }

      this.store.dispatch(setItemDisabledStatus({
        item: this.params.data,
        enable: isItemDisabled,
      }));
      return;
    }

    const currentTags: string[] = this.params?.data?._tags ?? [];
    this.params.data._tags = isItemDisabled
      ? currentTags.filter((tag: string) => tag !== 'disabled')
      : [...currentTags, 'disabled'];
    this.params.data.disabled = !this.params.data.disabled;
    GridUtils.updateIsEditedAndForceRefresh(this.params);

    const originalTags: string[] = this.params?.data?.originalValue?._tags?.value ?? [];
    const isNowDisabled: boolean = this.params.data._tags.includes('disabled');
    this.params.data.isEdited = isNowDisabled !== originalTags.includes('disabled');

    this.store.dispatch(setItemDisabledStatus({
      item: this.params.data,
      enable: !isNowDisabled,
    }));
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}



